var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"ui-arrow-link-back",attrs:{"to":_vm.route,"title":_vm.title}},[_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.ARROW_LINK_BACK,"text":_vm.text}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }